import { defined } from '../defined';
import { OnlineProductGroupFieldsFragment } from '../../graphql';

export const getIsProductGroupVisible = (
	groupsArray: OnlineProductGroupFieldsFragment[]
): ((id: number) => boolean) => {
	const knownVisibilities = new Map<number, boolean>();
	const groupsMap = new Map<number, OnlineProductGroupFieldsFragment>(
		groupsArray.map(group => [Number(group.id), group])
	);

	const isProductGroupVisible = (productGroupId: number): boolean => {
		if (knownVisibilities.has(productGroupId)) {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			return knownVisibilities.get(productGroupId)!;
		}

		const group = groupsMap.get(productGroupId);

		if (!group) {
			console.error(
				`isProductGroupVisible: product group w/ id ${productGroupId} could not be found`
			);

			knownVisibilities.set(productGroupId, false);

			return false;
		}

		if (!group.isVisible) {
			knownVisibilities.set(productGroupId, false);

			return false;
		}

		if (!defined(group.parentId) || group.parentId === 0) {
			knownVisibilities.set(productGroupId, group.isVisible);

			return group.isVisible;
		}

		const isVisible = isProductGroupVisible(group.parentId);

		knownVisibilities.set(productGroupId, isVisible);

		return isVisible;
	};

	return isProductGroupVisible;
};
